const state = {
  pH: null,
  K2O: null,
  P2O5: null,
  Humus: null,
  SoilTypeID: 2,
  ActiveBtn: 'btn2',
};

const getters = {
  ph: state => {
    return state.pH;
  },
  k2O: state => {
    return state.K2O;
  },
  p2O5: state => {
    return state.P2O5;
  },
  humus: state => {
    return state.Humus;
  },
  soilTypeId: state => {
    return state.SoilTypeID;
  },
  activeBtn: state => {
    return state.ActiveBtn;
  }
};

const mutations = {
  UpdatepH: (state, payload) => {
    state.pH = payload;
  },
  UpdateK2O: (state, payload) => {
    state.K2O = payload;
  },
  UpdateP2O5: (state, payload) => {
    state.P2O5 = payload;
  },
  UpdateHumus: (state, payload) => {
    state.Humus = payload;
  },
  UpdateSoilTypeId: (state, payload) => {
    state.SoilTypeID = payload;
  },
  UpdateAciveBtn: (state, payload) => {
    state.ActiveBtn = payload;
  }
};

const actions = {
  UpdatepH ({ commit }, payload) {
    commit('UpdatepH', payload);
  },
  UpdateK2O ({ commit }, payload) {
    commit('UpdateK2O', payload);
  },
  UpdateP2O5 ({ commit }, payload) {
    commit('UpdateP2O5', payload);
  },
  UpdateHumus ({ commit }, payload) {
    commit('UpdateHumus', payload);
  },
  UpdateSoilTypeId ({ commit }, payload) {
    commit('UpdateSoilTypeId', payload);
  },
  UpdateAciveBtn ({ commit }, payload) {
    commit('UpdateAciveBtn', payload);
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
